// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"2d6bd4ad","554":"7a4247f3","589":"aa1dcad8","787":"b25516f3"}[chunkId] + ".chunk.js";
};